// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"42a6073b","237":"98303072","324":"02f9b866","418":"0d32d91f","533":"a6306ae9","539":"c97edb68"}[chunkId] + ".chunk.js";
};